<template>
    <div
        class="menu-container pa-2"
        :style="{left: `${horizontal}px`, top: `${vertical}px`, backgroundColor: 'white'}"
    >
        <div
            class="d-flex align-center pa-2 rack-menu-item"
            @click.stop="handleClick('edit')"
        >
            <v-icon class="rack-menu-icon">create</v-icon>
            <p class="rack-menu-option">Edit Rack</p>
        </div>
        <div
            class="d-flex align-center pa-2 rack-menu-item"
            @click.stop="handleClick('delete')"
        >
            <v-icon class="rack-menu-icon">delete</v-icon>
            <p class="rack-menu-option">Delete Rack</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "RackOptionsMenu",
    components: {
    },
    props: {
        horizontal: {
            type: Number,
        },
        vertical: {
            type: Number,
        },
    },
    data() {
        return {
            active: false,
        };
    },
    computed: {

    },
    methods: {
        handleClick(action) {
            switch (action) {
                case "edit":
                    this.$emit('open-form', "rack", "edit");
                    break;
                case "delete":
                    this.$emit('delete-rack');
                    break;
                default:
                    break;
            }
            this.active = !this.active;
        },
    }
}
</script>

<style scoped>
.menu-container{
    position: absolute;
    box-shadow: 1px 1px 5px rgb(88, 88, 88);
    display: flex;
    flex-direction: column;
    border-radius: 5px;
}
.rack-menu-option{
    margin-bottom: 0px;
    margin-left: 5px;
}
.rack-menu-icon{
    font-size: 15px !important;
    transition: none !important;
}
.rack-menu-item{
    cursor: pointer;
    border-radius: 5px;
}
.rack-menu-item:active {
    background-color: #42A1B6;
}

.rack-menu-item:hover {
  color: white;
  background-color: #42A1B6;
}
.rack-menu-item:hover .rack-menu-icon {
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/menus/RackOptionsMenu.vue